import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6dcab32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "programChartButtonColor" }
const _hoisted_2 = { class: "content1" }
const _hoisted_3 = { class: "type" }
const _hoisted_4 = { class: "type-number" }
const _hoisted_5 = { class: "status" }
const _hoisted_6 = { class: "status1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ongoing" }, "进行中", -1))
const _hoisted_8 = { class: "ongoing-number" }
const _hoisted_9 = { class: "status2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pausing" }, "已暂停", -1))
const _hoisted_11 = { class: "pausing-number" }
const _hoisted_12 = { class: "status3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "completed" }, "已完成", -1))
const _hoisted_14 = { class: "completed-number" }

import rectChart from '@/components/rectChart.vue';
import { onMounted, toRefs } from 'vue';
import { ref } from 'vue';
interface projectNumInfoInterface{
    type: string;
    number: number;
    ongoing_num: number;
    paused_num: number;
    completed_num: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'programChart',
  props: {
    type: {},
    number: {},
    ongoing_num: {},
    paused_num: {},
    completed_num: {}
  },
  setup(__props: any) {

const projectNumInfo = __props;





onMounted(()=>{
    //console.log('projectNumInfo',projectNumInfo)
})

//使用父组件传递过来的值


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(projectNumInfo.type), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(projectNumInfo.number), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(projectNumInfo.ongoing_num), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(projectNumInfo.paused_num), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(projectNumInfo.completed_num), 1)
        ])
      ])
    ])
  ]))
}
}

})